module.exports = __webpack_public_path__ + "static/media/Spotify_Icon_RGB_Green.7a34cf42.png";